import { motion } from "framer-motion";
import { ArrowUpRight, ArrowUp } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/data/content";

export default function FinalCta() {
  return (
    <section
      className="relative overflow-hidden bg-royal py-32 md:py-48"
      data-testid="final-cta-section"
    >
      <div
        className="pointer-events-none absolute inset-0 flex items-center justify-center"
        aria-hidden
      >
        <span className="text-stroke-white select-none whitespace-nowrap font-display text-[20vw] font-bold leading-none">
          Vamos
        </span>
      </div>
      <div
        className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 animate-spin-slow rounded-full border border-dashed border-white/20"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-32 -right-20 h-[28rem] w-[28rem] rounded-full border border-white/15"
        aria-hidden
      />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-white/70">
            O próximo capítulo da tua marca
          </p>
          <h2 className="mt-6 max-w-4xl font-display text-5xl font-medium leading-[1.03] tracking-tight text-white md:text-7xl">
            Vamos criar algo que <em>importa.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
            Tens uma ideia, uma marca ou um projeto que queres levar mais longe? Vamos conversar.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap gap-4">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => scrollToId("#contacto")}
              className="group flex items-center gap-3 rounded-full bg-white px-8 py-4 text-sm font-bold text-royal transition-all duration-500 hover:shadow-[0_16px_48px_rgba(11,19,40,0.35)]"
              data-testid="final-cta-primary"
            >
              Falar com a Creative
              <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />
            </motion.button>
            <button
              onClick={() => scrollToId("#projetos")}
              className="group flex items-center gap-3 rounded-full border border-white/40 px-8 py-4 text-sm font-bold text-white transition-all duration-500 hover:border-white hover:bg-white/10"
              data-testid="final-cta-secondary"
            >
              Ver projetos
              <ArrowUp className="h-4 w-4 transition-transform duration-500 group-hover:-translate-y-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
